// extracted by mini-css-extract-plugin
module.exports = {"score":"_8579855","highlighted":"_1f1699f"};